const NO_PHASE = {
  id: -1,
  name: "– No Phase –",
  color: "var(--no-phase)",
}

export { NO_PHASE }
